import { getData } from '../../constants/asyncStatuses';
import { getMessages } from 'conversations-message-history/thread-history/operators/getters';
import { shouldExcludeMessage } from '../../pubsub/util/filterRejectedMessages';
import { removeRejectedMessagesForThread } from '../../pubsub/reducers/rejectedMessagesSlice';
import { getRejectedMessageIdsForThread } from '../../pubsub/selectors/getRejectedMessage';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
// @ts-expect-error untyped module
import { getCurrentThreadHistoryEntry } from '../../thread-history/selectors/getCurrentThreadHistoryEntry';
import { getSelectedThreadId } from '../../selected-thread/selectors/getSelectedThreadId';
import { STUBBED_THREAD_ID } from '../../threads/constants/stubbedThreadId';
// @ts-expect-error untyped module
import { removeMessageInConversation } from './removeMessageInConversation';
// @ts-expect-error untyped module
import { fetchThreadHistory } from './fetchThreadHistory';
export const refreshWithRejectedMessageFilter = () => (dispatch, getState) => {
  const state = getState();
  const resolvedThreadId = getSelectedThreadId(state);
  const sessionId = getSessionId(state);
  if (resolvedThreadId === null || resolvedThreadId === STUBBED_THREAD_ID) {
    return;
  }
  const rejectedMessageIds = getRejectedMessageIdsForThread(state, resolvedThreadId);
  if (rejectedMessageIds.size === 0) {
    return;
  }
  dispatch(removeRejectedMessagesForThread({
    threadId: resolvedThreadId
  }));
  dispatch(fetchThreadHistory({
    threadId: resolvedThreadId,
    sessionId
  })).then(() => {
    const currentState = getState();
    const entry = getCurrentThreadHistoryEntry(currentState);
    const historyData = entry ? getData(entry) : null;
    const messages = historyData ? getMessages(historyData) : null;
    if (!messages) {
      return;
    }
    messages.forEach(message => {
      if (shouldExcludeMessage(message, rejectedMessageIds)) {
        dispatch(removeMessageInConversation({
          message,
          threadId: resolvedThreadId
        }));
      }
    });
  }).catch(() => {});
};